
    import { Vue, Component, Watch, Inject } from 'vue-property-decorator'
    import Layout from '../../common/components/layout/layout.vue'
    import { NotificationDispatcher } from '@/app/common/services/notification-dispatcher.service'
    import { mapState } from 'vuex'
    import { Consumer } from '@/app/identity'

    @Component({
        components: { Layout },
        computed: {
            ...mapState('auth', ['consumer'])
        }
    })
    export default class CommunicationSettings extends Vue {
        consumer!: Consumer
        loading = false

        commercialConsent = false
        contactMethods = {
            email: false,
            phone: false,
            post: false
        }
        private isUpdatingFromContactMethods = false
        private isInitializing = false

        @Inject() notificationDispatcher!: NotificationDispatcher
        @Inject() updateMarketingCampaignPreferenceCommand!: any

        setAllContactMethods(value: boolean) {
            this.contactMethods.email = value
            this.contactMethods.phone = value
            this.contactMethods.post = value
        }

        @Watch('commercialConsent')
        onCommercialConsentChange(newVal: boolean) {
            if (!this.isUpdatingFromContactMethods && !this.isInitializing) {
                this.setAllContactMethods(newVal)
            }
        }

        @Watch('contactMethods', { deep: true })
        onContactMethodsChange() {
            if (this.isInitializing) return

            const anyEnabled = this.contactMethods.email || this.contactMethods.phone || this.contactMethods.post
            const allDisabled = !this.contactMethods.email && !this.contactMethods.phone && !this.contactMethods.post

            if (anyEnabled && !this.commercialConsent) {
                this.isUpdatingFromContactMethods = true
                this.commercialConsent = true
                this.$nextTick(() => {
                    this.isUpdatingFromContactMethods = false
                })
            } else if (allDisabled && this.commercialConsent) {
                this.isUpdatingFromContactMethods = true
                this.commercialConsent = false
                this.$nextTick(() => {
                    this.isUpdatingFromContactMethods = false
                })
            }
        }

        mounted() {
            this.initializePreferences()
        }

        initializePreferences() {
            this.isInitializing = true
            const pref = this.consumer?.marketingCampaignPreference
            if (pref) {
                this.contactMethods.email = pref.email
                this.contactMethods.phone = pref.phone
                this.contactMethods.post = pref.post
                this.commercialConsent = pref.enabled
            }
            this.$nextTick(() => {
                this.isInitializing = false
            })
        }

        @Watch('consumer', { deep: true })
        onConsumerChange() {
            this.initializePreferences()
        }

        async savePreferences() {
            try {
                this.loading = true
                const updatedPreferences = {
                    consumer_api_id: this.consumer.id,
                    enabled: this.commercialConsent,
                    email: this.contactMethods.email,
                    phone: this.contactMethods.phone,
                    post: this.contactMethods.post
                }
                await this.updateMarketingCampaignPreferenceCommand.run(updatedPreferences)

                const updatedConsumer = new Consumer({
                    ...this.consumer,
                    marketingCampaignPreference: {
                        enabled: updatedPreferences.enabled,
                        email: updatedPreferences.email,
                        phone: updatedPreferences.phone,
                        post: updatedPreferences.post
                    }
                })

                await this.$store.dispatch('auth/updateConsumer', updatedConsumer)
                await this.notificationDispatcher.success(
                    this.$t('page.communication_preference.success_message') as string
                )
            } catch (err) {
                await this.notificationDispatcher.error((err as Error).message)
            } finally {
                this.loading = false
            }
        }
    }
